// Decoded where it can be and left as it was written where it cannot: a `%` that opens nothing is a character
// somebody typed, and dropping the text would lose it. What went wrong is said beside the row instead.
export function decodePart(text: string): { text: string; error: string | null } {
  // A query is form-encoded, so a `+` in it is a space: every server reads one that way and so does URLSearchParams.
  const spaced = text.replace(/\+/g, " ");
  try {
    return { text: decodeURIComponent(spaced), error: null };
  } catch {
    return { text: spaced, error: "A percent escape here opens nothing" };
  }
}

// The space it writes back is `%20` rather than the `+` it may have been read from — the two mean the same thing in a
// query, and only one of them means it anywhere else the value is ever pasted.
export function encodePart(text: string): string {
  try {
    return encodeURIComponent(text);
  } catch {
    // A lone surrogate is half a character with no UTF-8 to be escaped into; the delimiters go and the rest stays.
    return text.replace(/[%&=#?+ ]/g, (char) => `%${char.charCodeAt(0).toString(16).toUpperCase()}`);
  }
}
